function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const elementsContext = /*#__PURE__*/React.createContext({
  elements: {},
  base: {
    Image: /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement("img", _extends({
      ref: ref
    }, props))),
    Link: /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement("a", _extends({
      ref: ref
    }, props))),
    PageLink: /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement("a", _extends({
      ref: ref
    }, props))),
    Head: () => null,
    imageLoader: props => props.src,
    useRouter: () => {}
  },
  props: {},
  mode: "edit"
});
const {
  Provider,
  Consumer
} = elementsContext;
export { Provider, Consumer };
export default elementsContext;
//# sourceMappingURL=elementsContext.js.map